























import { computed, defineComponent, PropType } from "@vue/composition-api";
import { Location } from "vue-router";
import { UserPublicData as OrigUserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import { UserWithVerificationStatus } from "@/types";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseAvatar from "@/components/BaseAvatar";

export default defineComponent({
  name: "AvatarDescription",
  components: { BaseIcon, BaseAvatar },
  props: {
    userData: {
      type: Object as PropType<UserPublicData | OrigUserPublicData | UserWithVerificationStatus | null>,
      required: true,
    },
    avatarSize: { type: Number, default: 56 },
    title: { type: String },
    description: { type: String },
    to: Object as () => Location,
    borderBottom: { type: Boolean, default: false },
    showVerifiedIcon: { type: Boolean, default: false },
  },
  setup(props) {
    const isUserVerified = computed(() => {
      if (props.userData && "verified" in props.userData) {
        return props.userData.verified;
      }
      return false;
    });

    return {
      isUserVerified,
    };
  },
});
